import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumbs, Typography } from "@mui/material";
import { NavigateNextOutlined } from "@mui/icons-material";
import customHttp from "../../services/customHTTP";

const BreadCrumbs = () => {
	const location = useLocation();
	const pathnames = location.pathname.split("/").filter((x) => x);

	// State to hold fetched names
	const [machineName, setMachineName] = useState(null);
	const [productName, setProductName] = useState(null);
	const [orderName, setOrderName] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			// Check if it's a machines path and fetch machine name if needed
			if (pathnames[0] === "machines" && pathnames[1]) {
				try {
					const response = await customHttp.post("/machines/by-ids", {
						machines: [pathnames[1]],
					});
					if (response.status === 200 && response.data.success) {
						setMachineName(response.data.data[0].machine_name);
					} else {
						setMachineName(pathnames[1]); // Revert to ID if failed
					}
				} catch (error) {
					console.error("Error fetching machine name:", error);
					setMachineName(pathnames[1]); // Revert to ID on error
				}
			}

			if (pathnames[0] === "documents" && pathnames[1]) {
				try {
					const response = await customHttp.post("/machines/by-ids", {
						machines: [pathnames[1]],
					});
					if (response.status === 200 && response.data.success) {
						setMachineName(response.data.data[0].machine_name);
					} else {
						setMachineName(pathnames[1]); // Revert to ID if failed
					}
				} catch (error) {
					console.error("Error fetching machine name:", error);
					setMachineName(pathnames[1]); // Revert to ID on error
				}
			}

			// Check if it's a machines path and fetch product name if needed
			if (pathnames[0] === "machines" && pathnames[1] && pathnames[2]) {
				try {
					const response = await customHttp.post("/products/getsingle", {
						machine_id: pathnames[1],
						product_id: pathnames[2],
					});
					if (response.status === 200 && response.data.success) {
						setProductName(response.data.data[0].product_name);
					} else {
						setProductName(pathnames[2]); // Revert to ID if failed
					}
				} catch (error) {
					console.error("Error fetching product name:", error);
					setProductName(pathnames[2]); // Revert to ID on error
				}
			}

			// Check if it's an order path and fetch order name if needed
			if (pathnames[0] === "quote-received" && pathnames[1]) {
				try {
					const response = await customHttp.post("/orders/getOrderByKey", {
						orderKey: pathnames[1],
					});
					if (response.status === 200) {
						setOrderName(response.data.data.order.order_number);
					} else {
						setOrderName(pathnames[1]); // Revert to ID if failed
					}
				} catch (error) {
					console.error("Error fetching order name:", error);
					setOrderName(pathnames[1]); // Revert to ID on error
				}
			}
		};

		fetchData();
	}, [pathnames]);

	function toCamelCase(str) {
		console.log("Spiltted: ", str.split("_"));
		return str
			.split("_")
			.map((word, index) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(" ");
	}

	const breadcrumbItems = pathnames.map((value, index) => {
		const to = `/${pathnames.slice(0, index + 1).join("/")}`;
		let displayValue = value;

		// Determine which value to display based on the index and API results
		if (pathnames[0] === "machines" && index === 1 && machineName) {
			displayValue = machineName;
		} else if (pathnames[0] === "documents" && index === 1 && machineName) {
			displayValue = machineName;
		} else if (pathnames[0] === "machines" && index === 2 && productName) {
			displayValue = productName;
		} else if (pathnames[0] === "quoteReceived" && index === 1 && orderName) {
			displayValue = orderName;
		} else if (pathnames[0] === "saved_for_later") {
			const transformedPathnames = toCamelCase(pathnames[0]);
			displayValue = transformedPathnames;
		}

		// Capitalize each breadcrumb item
		const capitalizedValue = displayValue.charAt(0).toUpperCase() + displayValue.slice(1).replace(/-/g, " ");
		return (
			<Link key={to} to={to}>
				<Typography color="black" fontSize="12px">
					{capitalizedValue}
				</Typography>
			</Link>
		);
	});

	return (
		<Breadcrumbs
			separator={<NavigateNextOutlined fontSize="small" />}
			aria-label="breadcrumb"
			style={{ marginTop: "10px", padding: "0 30px" }}>
			<Link to="/home">
				<Typography color="primary" fontSize="12px">
					Home
				</Typography>
			</Link>
			{breadcrumbItems}
		</Breadcrumbs>
	);
};

export default BreadCrumbs;
